import { render, staticRenderFns } from "./ILoading.vue?vue&type=template&id=46a4a0ec&scoped=true&"
import script from "./ILoading.vue?vue&type=script&lang=js&"
export * from "./ILoading.vue?vue&type=script&lang=js&"
import style0 from "./ILoading.vue?vue&type=style&index=0&id=46a4a0ec&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46a4a0ec",
  null
  
)

export default component.exports